export default __webpack_public_path__ + "static/ibk_securities-8bb9078c56101ce69308e86c443aef62.png";